export default __webpack_public_path__ + "static/media/prize_meteor_chicken_rice.2eff728b.png";